/**
 * Проверяет, является ли ссылка ссылкой на принтер
 * @param {string} link - Ссылка для проверки
 * @returns {{isPrinterLink: boolean, printerId: string|null}} - Результат проверки и ID принтера (если найден)
 */
export function checkIsPrinterLink(link) {
  const match = link.match(
    /^https:\/\/t\.me\/([a-zA-Z0-9_]+)_bot\?startapp=printer_(\d+)$/,
  );

  return match
    ? { isPrinterLink: true, printerId: match[2] }
    : { isPrinterLink: false, printerId: null };
}
